module.exports = __webpack_public_path__ + "static/media/logo.db507453.png";